import FormValidator from 'validate-js'


const fields = [{
    name: 'payment-method',
    display: 'Zahlungsart',
    rules: 'required'
}, {
    name: 'surname',
    display: 'Nachname',
    rules: 'required'
}, {
    name: 'forename',
    display: 'Vorname',
    rules: 'required'
}, {
    name: 'street',
    display: 'Straße und Hausnummer',
    rules: 'required'
}, {
    name: 'zip',
    display: 'Postleitzahl',
    rules: 'required'
}, {
    name: 'place',
    display: 'Ort',
    rules: 'required'
}, {
    name: 'email',
    display: 'E-Mail',
    rules: 'required'
}, {
    name: 'email-confirm',
    display: 'E-Mail-Bestätigung',
    rules: 'required|matches[email]'
}]

const cb = (errors, event) => {

    let box = document.querySelector('.error-box')

    if( errors.length > 0 ) {

        let errorString = '',
            errorLength = errors.length,
            formField   = document.querySelectorAll('.form-field'),
            inputField

        // reset errors
        for( let i = 0; i < formField.length; i++ )
            formField[i].classList.remove('has-error')

        for( let i = 0;  i < errorLength; i++ ) {

             // write message
            errorString += errors[i].message + '<br>'

            // set error class
            inputField = document.getElementsByName(errors[i].name)

            for( let x = 0; x < inputField.length; x++ )
                inputField[x].parentNode.classList.add('has-error')

        }

        box.children[0].innerHTML = errorString
        box.classList.add('is-visible')
    }

}


const validator = new FormValidator('book-order', fields, cb)

validator.setMessage('required', 'Bitte füllen Sie das Feld %s aus.');
validator.setMessage('matches', 'Die %s stimmt nicht überein.');



// WEBPACK FOOTER //
// ./src/js/modules/validate.js